import * as React from 'react'
import type { SVGProps } from 'react'
const SvgBars = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<path d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z" fill="currentColor" />
	</svg>
)
export default SvgBars
